import React, { useContext } from "react"
import PropTypes from "prop-types"
import { ThemeContext } from "styled-components"
import { Tag } from "@zendeskgarden/react-tags"

const ThemedTag = ({ className, children, ...props }) => {
  const themeContext = useContext(ThemeContext)
  return (
    <Tag
      className={className}
      hue={themeContext.colors.tag.background}
      {...props} // eslint-disable-line react/jsx-props-no-spreading
    >
      {children}
    </Tag>
  )
}

ThemedTag.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired
}

ThemedTag.defaultProps = {
  className: null
}

export default ThemedTag
